import { PageKey } from '@core/enums/page-keys.enum';
import { FlowId, type CheckinWorkflow } from '../workflow-engine.types';

export enum CheckinSummaryStep {
  Summary = 'Summary',
}

export const checkinSummaryFlow: CheckinWorkflow<CheckinSummaryStep> = {
  id: FlowId.CheckinSummary,
  entry: CheckinSummaryStep.Summary,
  steps: {
    [CheckinSummaryStep.Summary]: {
      id: CheckinSummaryStep.Summary,
      page: PageKey.CHECK_IN_SUMMARY,
      next: () => ({ complete: true }),
      exit: () => ({ bubble: 'exit' }),
    },
  },
};
